const OnlineTaskType = Object.freeze({
    ADD_PAYMENTS: 'addPayments',
    CONFIRM_ORDER: 'confirmOrder',
    CREATE_ORDER: 'createOrder',
    REDEMPTION: 'redemption',
    SAVE_TRADING_SESSION_ENTRY: 'saveTradingSessionEntry',
});

module.exports = OnlineTaskType;
